import React from "react";

interface UpRightShortIconProps {
    className?: string;
}

export const UpRightShortIcon: React.FC<UpRightShortIconProps> = ({ className = "" }) => {
    return (
        <svg 
            className={className}
            width="27" 
            height="27" 
            viewBox="0 0 27 27" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <path 
                d="M24.7458 27C23.5067 27 22.5022 25.9954 22.5022 24.7562V2.24391C22.5022 1.00472 23.5067 0.000149423 24.7458 0.000149423C25.985 0.000149423 26.9895 1.00472 26.9895 2.24392V24.7562C26.9895 25.9954 25.985 27 24.7458 27Z" 
                fill="currentColor"
            />
            <path 
                d="M0 2.24377C0 1.00457 1.00451 0 2.24363 0H24.7564C25.9955 0 27 1.00457 27 2.24377C27 3.48297 25.9955 4.48753 24.7564 4.48753H2.24363C1.00451 4.48753 0 3.48297 0 2.24377Z" 
                fill="currentColor"
            />
            <path 
                d="M1.6302 25.3645C0.754009 24.4882 0.754009 23.0676 1.6302 22.1913L23.1616 0.658574C24.0378 -0.217671 25.4584 -0.217672 26.3346 0.658574C27.2108 1.53482 27.2108 2.95549 26.3346 3.83174L4.80318 25.3645C3.92698 26.2407 2.50639 26.2407 1.6302 25.3645Z" 
                fill="currentColor"
            />
        </svg>
    );
};